import React, { Fragment } from 'react'

import i18n from 'i18next'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool, number } from 'prop-types'

import DiscountIcon from './Components/DiscountIcon/DiscountIcon'

const getTooltipContent = (threshold, locale) => `
  <div class="product-list__price-description-text">
    ${i18n.t('navigation.cart_widget.sale_tooltip_text', { ns: 'rails', lng: locale, threshold })}
  </div>
`

function Price({ isCartBelowThreshold, isDiscountApplicable, price, threshold = 0, locale = 'en' }) {
  if (isDiscountApplicable) {
    if (isCartBelowThreshold && threshold && threshold > 0) {
      const tooltipContent = getTooltipContent(threshold, locale)
      return (
        <Tooltip
          id="tooltip-id"
          randomizeID
          html
          place="top"
          content={tooltipContent}
          className="product-list__price-description"
        >
          <DiscountIcon />
          {price}
        </Tooltip>
      )
    }

    return (
      <Fragment>
        <DiscountIcon />
        {price}
      </Fragment>
    )
  }

  return price
}

Price.propTypes = {
  isCartBelowThreshold: bool.isRequired,
  isDiscountApplicable: bool.isRequired,
  price: string.isRequired,
  threshold: number,
  locale: string,
}

export default Price
